import React from "react";
import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Products from "@/components/sections/Products";
import AIMarketplace from "@/components/sections/AIMarketplace";
import Industries from "@/components/sections/Industries";
import Pricing from "@/components/sections/Pricing";
import Portfolio from "@/components/sections/Portfolio";
import Testimonials from "@/components/sections/Testimonials";
import Blog from "@/components/sections/Blog";
import ContactSection from "@/components/sections/ContactSection";
import { useLocation } from "react-router-dom";

export default function HomePage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [hash]);

  return (
    <div data-testid="home-page">
      <Hero />
      <div className="divider-gold container-px"><div className="mx-auto max-w-7xl" /></div>
      <About />
      <Services />
      <Products />
      <AIMarketplace />
      <Industries />
      <Pricing />
      <Portfolio />
      <Testimonials />
      <Blog />
      <ContactSection />
    </div>
  );
}
